import { find } from 'ramda';
import Http from '../../../../http';
import { FETCH_SIDE_BY_SIDE, START_FETCH_SIDE_BY_SIDE } from './constants';

export const fetchShopSideBySide = (shopId, date, showLoading) => async (dispatch) => {
  if (showLoading) {
    dispatch({
      type: START_FETCH_SIDE_BY_SIDE,
    });
  }

  const result = await Http.get(`/shop/${shopId}/timesheet/${date}`);
  const currentDay = find(item => item.date === date, result);
  return dispatch({
    type: FETCH_SIDE_BY_SIDE,
    payload: currentDay,
  });
};

export const fetchBarberSideBySide = (barberId, date, showLoading) => async (dispatch) => {
  if (showLoading) {
    dispatch({
      type: START_FETCH_SIDE_BY_SIDE,
    });
  }

  const result = await Http.get(`/barber/${barberId}/timesheet/${date}`);
  const currentDay = find(item => item.date === date, result);
  return dispatch({
    type: FETCH_SIDE_BY_SIDE,
    payload: currentDay,
  });
};
